export const environment = {
  production: true,
  webSocketBaseUrl: window.location.host,
  webSocketMaxConnectRetries: 10
};
